'use client';
import React, { FC, memo, ReactNode } from 'react';
import styles from './index.module.scss';
// import cls from 'classnames';
import { Button } from '@bfe/moly';

export interface Props {
  text?: ReactNode;
  refresh?: ReactNode;
  onRefresh?: () => void;
}

const Empty: FC<Props> = ({ text, refresh, onRefresh }) => {
  return (
    <div className={styles.empty}>
      <p>{text || 'No data'}</p>
      {onRefresh && (
        <Button className={styles.btn} variant="primary" onClick={onRefresh}>
          <i className="moly-iconfont bit-icon_refresh" />
          {refresh || 'Refresh'}
        </Button>
      )}
    </div>
  );
};

export default memo(Empty);
